import React from 'react';
import { useTranslation } from 'react-i18next';
import { AttachmentCountBadge } from '@/components/DiaryLessonCard/AttachmentCountBadge';
import { DiaryText } from '@/components/DiaryTextList/DiaryText';
import { TestPaper } from '@/components/Icons/TestPaper';
import type { TextWithAttachments } from '@/types/diary';
import { isBlank } from '@/utils/text';

interface Props {
  test: TextWithAttachments;
  hasEmptyPlaceholder?: boolean;
  isAttachmentCountShown?: boolean;
}

export const LessonScheduledTest: React.FC<Props> = ({
  test,
  hasEmptyPlaceholder,
  isAttachmentCountShown,
}) => {
  const { t } = useTranslation();
  const hasText = !isBlank(test.text);
  const isTitleOnly = !hasText && !hasEmptyPlaceholder;
  const attachmentCount = test.attachments.length;

  return (
    <div
      className={`flex gap-3 ${isTitleOnly ? 'items-center' : 'items-start'}`}
    >
      <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-info-surface text-primary">
        <TestPaper className="size-4" />
      </span>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <div className="flex items-start justify-between gap-4">
          <span className="text-caption-13 text-foreground md:text-subhead-14">
            {t('diary.plannedTest')}
          </span>
          {isAttachmentCountShown && attachmentCount > 0 && (
            <AttachmentCountBadge count={attachmentCount} />
          )}
        </div>
        {hasText && (
          <div className="text-body-14 text-muted-foreground">
            <DiaryText isFullText text={test.text} />
          </div>
        )}
        {!hasText && hasEmptyPlaceholder && (
          <p className="text-body-14 text-muted-foreground">
            {t('diary.emptyDescription')}
          </p>
        )}
      </div>
    </div>
  );
};
